import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackButton from "../../../../../../common/elements/BackButton";
import WistiaVideoPlayer from '../../../../../../common/media/WistiaVideoPlayer'

class DisplayModule extends Component {
    render() {

        const { module, courseName } = this.props;
        const wistiaUrl = module.id === 1 && 'https://fast.wistia.net/embed/iframe/rhs6r11jgm?videoFoam=true'
            || module.id === 30 && 'https://fast.wistia.net/embed/iframe/gw6kh1aock?videoFoam=true'
            || module.id > 50 && `https://fast.wistia.net/embed/iframe/${module.url.split('/')[4]}/?videoFoam=true`;

        return (
            <section className="row course-header">
                <BackButton/>
                    <div className="col-xs-12 text-center">
                        <h1 className="h1">{ courseName }</h1>
                        <h2 classname="h2">{ module.name }</h2>
                        { ( module.id === 1 || module.id === 30 || module.id > 50 )
                            ? <WistiaVideoPlayer url={ wistiaUrl }/>
                            :
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe id="player1" className="embed-responsive-item video-courses"
                                    src={ `${ module.url }?api=1&player_id=player1` } allowFullScreen/>
                        </div> }
                    </div>
            </section>
        );

    }

}

DisplayModule.propTypes = {
    module: PropTypes.object.isRequired,
};

export default DisplayModule;


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/DisplayModule.js